import { render, staticRenderFns } from "./FilePreviewDialog.vue?vue&type=template&id=24cb6420&scoped=true&"
import script from "./FilePreviewDialog.vue?vue&type=script&lang=ts&"
export * from "./FilePreviewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FilePreviewDialog.vue?vue&type=style&index=0&id=24cb6420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb6420",
  null
  
)

export default component.exports